// extracted by mini-css-extract-plugin
export default {"createPricing":"CreatePricingType_createPricing__QMd33","createPricing__form":"CreatePricingType_createPricing__form__Wor1m"};